module.exports = __webpack_public_path__ + "img/BLCA_DC.49834c42.png";